import { useDataProvider } from "react-admin";
import { useQuery } from "react-query";

import {
  AccountFlagsResponse,
  AccountResponse,
  CustomDataProvider,
} from "../types";
import { getIsAiEnabled } from "../utils/AccountFlags";

function useAccountIsAiEnabled(
  accountRecord: Pick<AccountResponse, "id" | "is_ai_enabled"> | undefined,
) {
  const dataProvider = useDataProvider<CustomDataProvider>();
  const { data } = useQuery<{ data: AccountFlagsResponse }>(
    ["getAccountFlags", { id: accountRecord?.id }],
    () => dataProvider.getAccountFlags(accountRecord?.id as number),
    { enabled: Boolean(accountRecord) },
  );

  return getIsAiEnabled(accountRecord, data?.data);
}

export default useAccountIsAiEnabled;
